import { apiContractRequest } from "./client";

export const PUBLIC_SELLER_PROGRAM_CONTRACT = "/api/public/webprofit/sellers";

export function getPublicSellerProgram() {
  return apiContractRequest(PUBLIC_SELLER_PROGRAM_CONTRACT, {
    method: "GET",
    withCredentials: false,
  });
}
